import { getGoodsOffer } from '../../api/v2/requests/goods-offers';

export default {
  namespaced: true,
  state: {
    currentGoodsOffer: null,
    isLoading: false,
    error: null,
  },
  mutations: {
    SET_CURRENT_GOODS_OFFER(state, offer) {
      state.currentGoodsOffer = offer;
    },
    SET_LOADING(state, loading) {
      state.isLoading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    CLEAR_CURRENT_GOODS_OFFER(state) {
      state.currentGoodsOffer = null;
      state.error = null;
    },
  },
  getters: {
    currentGoodsOffer: (state) => state.currentGoodsOffer,
    isLoading: (state) => state.isLoading,
    error: (state) => state.error,
  },
  actions: {
    async fetchGoodsOffer({ commit }, id) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      try {
        const offer = await getGoodsOffer(id);
        commit('SET_CURRENT_GOODS_OFFER', offer);
        return offer;
      } catch (error) {
        commit('SET_ERROR', 'Failed to fetch goods offer');
        console.error('Error fetching goods offer:', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    clearGoodsOffer({ commit }) {
      commit('CLEAR_CURRENT_GOODS_OFFER');
    },
  },
};
